import { useState } from 'react'
import { useTheme } from 'styled-components'
import { Button } from 'components'
import Markdown from 'react-markdown'
import InputEmoji from 'react-input-emoji'
import { runSlashCommand } from '../../commands'
import { decode, useRoshambo } from '../../roshambo'
import { getUserLabel } from '../user-label'
import { RoshamboCard } from '../roshambo-card'
import {
  Anchor,
  Container,
  ChatBox,
  Blurb,
  User,
  InputRow,
  EmojiWrapper,
} from './styles'

// Shared visual chrome for all chat views (user/host/admin). Role-specific
// components own data-fetching and pass comments + a send handler in.
export const ChatPanel = ({ comments, currentUserId, onSend }) => {
  const { colors } = useTheme()
  const [value, setValue] = useState('')
  const [systemMessages, setSystemMessages] = useState([])
  const { matches: roshamboMatches, run: runRoshambo } = useRoshambo({
    comments,
    currentUserId,
    onSend
  })

  const addSystemMessage = (text) => {
    setSystemMessages((prev) => [...prev, { id: `sys-${prev.length}`, text }])
  }

  const send = async () => {
    if (value === '') return
    const input = value
    setValue('')

    if (input.trim().startsWith('/roshambo')) {
      const args = input.trim().slice('/roshambo'.length).trim().split(/\s+/).filter(Boolean)
      const result = await runRoshambo(args)
      if (result.post) onSend(result.post)
      if (result.local) addSystemMessage(result.local)
      return
    }

    const command = runSlashCommand(input)
    if (command) {
      if (command.post) onSend(command.post)
      if (command.local) addSystemMessage(command.local)
    } else {
      onSend(input)
    }
  }

  return (
    <Container>
      <ChatBox>
        {comments?.map((comment) => {
          const payload = decode(comment.comment)
          if (payload) {
            return payload.type === 'challenge'
              ? (
              <RoshamboCard key={comment.id} match={roshamboMatches[payload.matchId]} />
                )
              : null
          }
          return (
            <Blurb
              className={comment.User.id === currentUserId ? 'current' : ''}
              key={comment.id}
            >
              <User>{getUserLabel(comment.User)}</User>
              <Markdown>{comment.comment}</Markdown>
            </Blurb>
          )
        })}
        {systemMessages.map((message) => (
          <Blurb className="system" key={message.id}>
            {message.text}
          </Blurb>
        ))}
        <Anchor />
      </ChatBox>
      <InputRow>
        <EmojiWrapper>
          <InputEmoji
            background={colors('chrome')}
            borderRadius="0"
            color={colors('text')}
            value={value}
            onChange={setValue}
            onEnter={send}
            placeholder="message... (/ for commands)"
          />
        </EmojiWrapper>
        <Button onPress={send}>Send</Button>
      </InputRow>
    </Container>
  )
}
